import { ILineItem, IOrderParams, IShoppingCartInfo, PurchasableType } from "@/types/order-types"
import { createUuid } from "."
import { IListing } from "@/types/menu-types"
import { IDeliveryAddress, IDiningMethods, IPickUpOption } from "@/types/common-types";
import { ITable } from "@/types/table-types";
import { initialDelivery } from "@/constants";
import dayjs from "dayjs";
import { getDeliveryDate, getRFCDate } from "./date-utils";
import paths from "@/pages/paths";

export const getDefaultLineItem = (listing: IListing) => {
  const item: ILineItem = {
    uuid: createUuid(),
    purchasable_type: PurchasableType.LISTING,
    purchasable_id: `${listing.id}`,
    price: `${listing.price}`,
    quantity: 1,
    total: `${listing.price}`,
    label: listing.name,
  }
  return item;
};

interface IGetOrderByShoppingCartParams {
  type: IDiningMethods;
  shoppingCartData: IShoppingCartInfo;
  businessID: string;
  table?: ITable;
  deliveryAddress?: IDeliveryAddress;
  pickUpOption?: IPickUpOption;
  language: string;
}

export const getOrderByShoppingCart = (params: IGetOrderByShoppingCartParams) => {
  const { type, shoppingCartData, businessID, table, deliveryAddress, pickUpOption, language } = params;
  const { favoriteIdLineItemRef } = shoppingCartData;
  const values = Object.values(favoriteIdLineItemRef);
  const refNo = `W-${new Date()
        .getTime()
        .toString()
        .substring(0, 12)}`;

  let order: IOrderParams = {
    order: {
      currency: 'HKD',
      reference_number: refNo,
      shipping_method: type,
      line_items: values,
      redirect_url: getOrderResultUrl(businessID, refNo, language),
      back_url: getBackUrl(),
    }
  };

  if (type === IDiningMethods.DELIVERY && deliveryAddress) {
    order.delivery_note = {
      ...deliveryAddress,
      address1: deliveryAddress.address,
      district: deliveryAddress.area,
    };
    delete order.delivery_note.address;
    delete order.delivery_note.area;
    order.order.initial_delivery = initialDelivery;
  } else if (type === IDiningMethods.DINE_IN) {
    order.party = {
      id: createUuid(),
      table_id: table?.id || '',
      table_name: table?.name || '',
      number_of_people: table?.seats || 1,
      seated_at: dayjs().format(),
      status: 'ordered',
    };
  } else if (type === IDiningMethods.TAKEAWAY && pickUpOption) {
    const cuurentDeliveryDate = pickUpOption.delivery_date;
    let deliveryDate = cuurentDeliveryDate;
    if (cuurentDeliveryDate === 'Immediately') {
      deliveryDate = getRFCDate();
    } else {
      deliveryDate = getDeliveryDate(cuurentDeliveryDate);
    }
    order.delivery_note = {
      ...pickUpOption,
      delivery_date: deliveryDate
    }
  }

  return order;
}

export const cleanRedirectUrl = (url: string) => {
  try {
    const urlObj = new URL(url);
    const searchParams = new URLSearchParams(urlObj.search);
    
    searchParams.delete('number');
    
    urlObj.search = searchParams.toString();
    return urlObj.toString();
  } catch (e) {

    return url;
  }
}

export const getOrderResultUrl = (businessID: string, refNo: string, language: string) => {
  const domain = window.location.origin;
  // let search = window.location.search || '';

  return `${domain}/${language}/${paths.ORDER_RESULT.replace(':businessID', businessID)}?refNo=${refNo}`;
}

export const getBackUrl = () => {

  return window.location.href;;
};
